import { MenuItem, TextField, Select } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { valueByName } from './form_utils';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RegFormType } from '@/api';
import Radio from '@mui/material/Radio';
import Grid from '@mui/material/Grid';

const PREFIX = 'ECRadioGroupField';
const classes = {};

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({}));

export const ECRadioGroupField = props => {
  const { name, options, form, defaultValue, initial, onchange, ...rest } = props;

  const fname =
    props.fname ||
    (it => {
      return it.name;
    });
  const fid =
    props.fid ||
    (it => {
      return it.id;
    });

  const [value, setValue] = useState(valueByName(initial, name) || defaultValue || null);

  useEffect(() => {
    form.register(name);
    form.setValue(name, value);
  }, [form.register]);

  const handleChange = e => {
    form.setValue(name, e.target.value);
    setValue(e.target.value);
    form.clearErrors(name);
    onchange && onchange(e.target.value);
  };

  return (
    <StyledRadioGroup {...rest} name='formType' value={value} onChange={handleChange}>
      {options.map(it => (
        <FormControlLabel key={fid(it)} value={fid(it)} control={<Radio />} label={fname(it)} />
      ))}
    </StyledRadioGroup>
  );
};

ECRadioGroupField.propTypes = {
  name: PropTypes.string,

  options: PropTypes.array,
  fname: PropTypes.func,
  fid: PropTypes.func,

  form: PropTypes.object,

  defaultValue: PropTypes.any,
  initial: PropTypes.any,
};
